import AppLinkButton from 'components/app/AppLinkButton';
import { BASE_IMG_URL } from '../../const/ConstBase';

import './MainTopBanner.scss';

export const MainTopBanner = () => {
    return (
        <div className='top_video_container'>
            <video className='top_video' autoPlay loop muted>
                <source
                    src={`${BASE_IMG_URL}main-top-img_animation.mp4`}
                    type='video/mp4'
                />
            </video>
            <div className='link-button-wrapper'>
                <AppLinkButton
                    buttonText='JOGUE AGORA'
                    link=''
                    isHover={false}
                />
            </div>
        </div>
    );
};
